// MOTD.js
import React, { useState, useContext, useEffect } from 'react';
import { TextareaAutosize, Button, Typography } from '@mui/material';
import { AuthContext } from '../AuthContextProvider';
import ErrorDialog from '../ErrorDialog';
import { useNavigate } from 'react-router-dom';
import { rpc } from '../utils/RpcUtils';
import '../App.css';

const DefaultMOTD = () => {
  const [message, setMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const onFetchSuccess = (motd) => {
      setMessage(motd.motd);
    };

    const fetchMotd = async () => {
      const params = {
        _site: user._site._id
      };
      rpc({
        method: 'GetDefaultMotd',
        params,
        setErrorMessage,
        setOpenErrorDialog,
        onSuccess: onFetchSuccess
      });
    };
    fetchMotd();
  }, [user]);

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const onSuccess = () => {
    navigate('/motds');
  };

  const updateMotd = async () => {
    if (message === '') {
      setErrorMessage('Message field is required');
      setOpenErrorDialog(true);
      return;
    }
    const params = {
      _site: user._site._id,
      motd: message,
    };
    rpc({
      method: 'UpdateDefaultMotd',
      params,
      setErrorMessage,
      setOpenErrorDialog,
      onSuccess
    });
  };

  const handleClose = () => {
    setOpenErrorDialog(false);
  };

  return (
    <div className="DefaultMOTD">
      <Typography variant="h6" gutterBottom>
        Default Message of the Day (MOTD)
      </Typography>
      <TextareaAutosize
        className="TextareaAutosize"
        aria-label="Message"
        placeholder="Enter your message here"
        minRows={3}
        value={message}
        onChange={handleMessageChange}
      />
      <Button className="Button" variant="contained" color="primary" onClick={updateMotd}>
        Save
      </Button>
      <ErrorDialog open={openErrorDialog} onErrorDialogClose={handleClose} errorMessage={errorMessage} />
    </div>
  );
};

export default DefaultMOTD;
